import { render, staticRenderFns } from "./BiasMatrix.vue?vue&type=template&id=05f3c797&"
import script from "./BiasMatrix.vue?vue&type=script&lang=js&"
export * from "./BiasMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VCard,VCardText,VContainer,VSimpleTable,VSlider})
